export const balanceTypes = {
  PLUS: '+',
  MINUS: '-',
  EQUAL: '=',
}
